// @ts-strict-ignore
import { IMoveArticlesOperation } from './i-move-articles-operation';
import { Dictionary } from 'typescript-collections';
import { Vector3 } from 'three';
import { MoveArticlesBetweenBlocksData } from '../data/move-articles-between-blocks-data';
import { CarrierBlockManager } from '@project/components/article/manager/carrier-block.manager';
import { ArticleMoveManager, ArticlesMovedHandlerData } from '@project/components/article/manager/article-move.manager';
import { UnusedLabelingService } from '@project/components/label/label-editor/service/unused-labeling.service';
import { LayerManager } from '@3d-scene/manager/layer-manager';
import { ProjectContentPresenter } from '../../presenter/project-content.presenter';
import { ProjectModel } from '@project/model/project.model';
import { InsertArticleUtils } from '@project/components/article/util/insert-article-utils';
import { BaseAdvancedOperation } from './base-advanced-operation';

export class UndoMoveArticlesOperation extends BaseAdvancedOperation implements IMoveArticlesOperation {
  constructor(
    private _carrierBlockManager: CarrierBlockManager,
    private _articleMoveManager: ArticleMoveManager,
    private _layerManager: LayerManager,
    private _projectContentPresenter: ProjectContentPresenter,
    private _unusedLabelingService: UnusedLabelingService,
    private _projectModel: ProjectModel,
    protected _insertArticleUtils: InsertArticleUtils,
    protected _moveArticlesMap: Dictionary<string, Vector3>,
    private _dispatchMessages: boolean = false,
    private _rebuildProjectTree: boolean = false,
    private _nonMovableArticlesMoved: boolean = false,
    private _articleUsageIds: string[] = null,
    private _articlesOrderChanged: boolean = false,
    private _moveArticlesBetweenBlocksDatas: MoveArticlesBetweenBlocksData[] = null
  ) {
    super();
  }

  public getQualifiedClassName(): string {
    return 'UndoMoveArticlesOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public getMoveArticlesMap(): Dictionary<string, Vector3> {
    return this._moveArticlesMap;
  }

  public isArticlesOrderChanged(): boolean {
    return this._articlesOrderChanged;
  }

  public isDistanceBetweenArticlesChanged(): boolean {
    return true;
  }

  public async performUndo(): Promise<void> {
    this._insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, true);
    super.performUndo();
    this.dispatchMoveMessage(true, true);
  }

  public async performRedo(): Promise<void> {
    this._insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, false);
    super.performRedo();
    this.dispatchMoveMessage(false, false);
  }

  protected dispatchMoveMessage(restoreBlock: boolean, negateOffset: boolean): void {
    if (this._dispatchMessages) {
      const data: ArticlesMovedHandlerData = {
        articleOrderChanged: this._rebuildProjectTree,
        nonMovableArticlesMoved: this._nonMovableArticlesMoved,
        articleUsageIds: this._articleUsageIds,
        moveArticlesMap: this.getMoveArticlesMapForMessage(negateOffset),
      };
      this._layerManager.deactivate('articlePosition');
      this._projectModel.projectChangeHandler();
      this._unusedLabelingService.articleContainerMovedHandler(data);
      this._articleMoveManager.articleContainerMovedHandler(data);
      this._projectContentPresenter.articleContainerMovedHandler(data);
      if (this._moveArticlesBetweenBlocksDatas && this._moveArticlesBetweenBlocksDatas.length > 0) {
        this._carrierBlockManager.articleContainersMovedFromCarrierBlock({
          moveArticlesBetweenBlocksDatas: this._moveArticlesBetweenBlocksDatas,
          restoreBlock: restoreBlock,
        });
      }
    }
  }

  private getMoveArticlesMapForMessage(negateOffset: boolean): Dictionary<string, Vector3> {
    const moveArticlesMap: Dictionary<string, Vector3> = new Dictionary();
    this._moveArticlesMap.forEach((key: string, value: Vector3) => {
      const offset: Vector3 = value.clone();
      if (negateOffset) {
        offset.negate();
      }
      moveArticlesMap.setValue(key, offset);
    });
    return moveArticlesMap;
  }
}
